import { Component, OnInit } from '@angular/core';
import { PaymentService, AcknowledgmentTemplate } from '@services/payment.service';
import { NotificationService } from '@services/notification.service';

@Component({
  selector: 'app-acknowledgment-template',
  templateUrl: './acknowledgment-template.component.html',
  styleUrls: ['./acknowledgment-template.component.css'],
})
export class AcknowledgmentTemplateComponent implements OnInit {
  template: AcknowledgmentTemplate = { name: '', body: '' };
  saving = false;

  constructor(
    private paymentService: PaymentService,
    private notification: NotificationService
  ) {}

  ngOnInit(): void {
    this.paymentService.getAckTemplate().subscribe((template) => {
      this.template = template || this.template;
    });
  }

  save(): void {
    this.saving = true;
    this.paymentService.saveAckTemplate(this.template).subscribe({
      next: (template) => {
        this.saving = false;
        this.template = template;
        this.notification.show('success', 'Acknowledgment template saved');
      },
      error: () => {
        this.saving = false;
        this.notification.show('error', 'Could not save template');
      },
    });
  }
}
